export interface ClientApiResource {
  id: string;
  full_name: string;
  email: string | null;
  phone: string | null;
  address_line: string | null;
  city: string | null;
  postal_code: string | null;
  country: string | null;
  preferred_language: string | null;
  status: string;
  portal_status: string;
  portal_invitation_expires_at?: string | null;
  anonymised_at?: string | null;
  pets_count: number;
}

export interface Client {
  id: string;
  fullName: string;
  email: string | null;
  phone: string | null;
  addressLine: string | null;
  city: string | null;
  postalCode: string | null;
  country: string | null;
  preferredLanguage: string | null;
  status: string;
  portalStatus: string;
  portalInvitationExpiresAt: string | null;
  anonymisedAt: string | null;
  petsCount: number;
}

export interface ClientWritePayload {
  fullName: string;
  email: string | null;
  phone: string | null;
  addressLine: string | null;
  city: string | null;
  postalCode: string | null;
  country: string | null;
  preferredLanguage: string | null;
}

export interface ClientProfilePayload {
  fullName?: string;
  phone?: string | null;
  addressLine?: string | null;
  city?: string | null;
  postalCode?: string | null;
  country?: string | null;
  preferredLanguage?: string | null;
}

export function mapApiResourceToClient(resource: ClientApiResource): Client {
  return {
    id: resource.id,
    fullName: resource.full_name,
    email: resource.email,
    phone: resource.phone,
    addressLine: resource.address_line,
    city: resource.city,
    postalCode: resource.postal_code,
    country: resource.country,
    preferredLanguage: resource.preferred_language,
    status: resource.status,
    portalStatus: resource.portal_status,
    portalInvitationExpiresAt:
      resource.portal_invitation_expires_at === undefined
        ? null
        : resource.portal_invitation_expires_at,
    anonymisedAt: resource.anonymised_at === undefined ? null : resource.anonymised_at,
    petsCount: resource.pets_count,
  };
}

export function mapClientWritePayload(payload: ClientWritePayload): Record<string, unknown> {
  return {
    full_name: payload.fullName,
    email: payload.email,
    phone: payload.phone,
    address_line: payload.addressLine,
    city: payload.city,
    postal_code: payload.postalCode,
    country: payload.country,
    preferred_language: payload.preferredLanguage,
  };
}
